import { render, staticRenderFns } from "./CompanyDashboard.vue?vue&type=template&id=037d3b06&scoped=true&lang=html&"
import script from "./CompanyDashboard.vue?vue&type=script&lang=js&"
export * from "./CompanyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDashboard.vue?vue&type=style&index=0&id=037d3b06&lang=scss&scoped=true&"
import style1 from "./CompanyDashboard.vue?vue&type=style&index=1&id=037d3b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d3b06",
  null
  
)

export default component.exports